/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class AutoCompleteConfigurationModel {
        public currentAutoComplete: Wars.Domain.Model.AutoCompleteConfiguration;
        public apiActions: Wars.Domain.Model.ApiAction[];
        public filteredApiActions: Wars.Domain.Model.ApiAction[];
        public autoCompleteConfigurations: Wars.Domain.Model.AutoCompleteConfiguration[];
        public processTypes: Wars.Domain.Model.ProcessType[];
        public selectedApiAction: Wars.Domain.Model.ApiAction;
        public objectQueries: Wars.Domain.Model.ObjectQuery[];
        public inputObjectSchema:Wars.Domain.Model.ObjectSchema;
        public outputObjectSchema:Wars.Domain.Model.ObjectSchema;


        constructor(private processConfigurationId: string, private autoCompleteService: services.AutoCompleteConfigurationService,
            private apiConfigurationService: services.ApiActionService,private systemLevelService:services.SystemLevelService) {

            this.apiConfigurationService.getApiConfigurations().then(r => {
                this.apiActions = r;

                this.processTypes = Enumerable.from(this.apiActions).select(a => a.processConfiguration.myProcessType).distinct().toArray();
            });

            this.systemLevelService.getSystemLevelObjectQueries().then(o => {
                this.objectQueries = o.myObjectQueries;
            });

            autoCompleteService.getAutoCompleteConfigurations(processConfigurationId).then(result => {
                this.autoCompleteConfigurations = result;
            });
        }

        public save() {
            this.autoCompleteService.saveAllChanges();
        }

        public selectAutoComplete(autoComplete: Wars.Domain.Model.AutoCompleteConfiguration) {
            this.currentAutoComplete = autoComplete;
            this.setFilteredApiActions();
        }

        public selectApiAction() {
            this.setSelectedApiAction();
            this.save();
        }

        private setSelectedApiAction() {
            this.selectedApiAction = Enumerable.from(this.filteredApiActions).singleOrDefault(a => a.uniqueId == this.currentAutoComplete.apiUniqueId);
            this.setObjectSchemas();
        }

        public addAutoComplete() {
            this.currentAutoComplete = this.autoCompleteService.createAutoCompleteConfiguration();
            this.currentAutoComplete.processConfiguration_id = this.processConfigurationId;
            this.currentAutoComplete.returnProcessId = false;
            this.autoCompleteConfigurations.push(this.currentAutoComplete);

            this.save();
        }

        private setFilteredApiActions() {
            this.filteredApiActions = Enumerable.from(this.apiActions).where(a => a.processConfiguration.processType_id == this.currentAutoComplete.processType_id)
                .distinct(a => a.uniqueId).toArray();

            this.setSelectedApiAction();
        }

        public objectQueryChanged() {
            this.currentAutoComplete.apiUniqueId = null;
            this.currentAutoComplete.processType_id = null;
            this.setObjectSchemas();

            this.save();
        }

        private setObjectSchemas() {
            if (this.currentAutoComplete.objectQuery_id) {
                this.inputObjectSchema = this.currentAutoComplete.objectQuery.myInputObjectSchema;
                this.outputObjectSchema= this.currentAutoComplete.objectQuery.myProjectionObjectSchema;
            } else if(this.currentAutoComplete.apiUniqueId) {
                this.inputObjectSchema = this.selectedApiAction.inputObjectSchema;
                this.outputObjectSchema = this.selectedApiAction.outputObjectSchema; 
            }
        }

        public processTypeChanged() {
            this.setFilteredApiActions();
            this.currentAutoComplete.apiUniqueId = null;

            this.save();
        }
    }
}